import { CalendarIcon } from '@heroicons/react/24/outline';

/**
 * Shared card for a CoreCycle (purpose / strategy / tactical). Same shape
 * used by all three horizon tabs — see ModalCoreCycleForm docstring.
 */
const CardCoreCycle = ({ cycle, onClick }) => {
  const hasDates = cycle.date_init || cycle.date_end;

  return (
    <div
      className="bg-white p-4 rounded-xl shadow hover:bg-gray-50 cursor-pointer transition flex gap-3"
      onClick={onClick}
    >
      {cycle.image_url && (
        <img
          src={cycle.image_url}
          alt=""
          className="w-16 h-16 object-cover rounded-lg border border-gray-200 flex-shrink-0"
        />
      )}
      <div className="min-w-0 flex-1">
        <h3 className="text-md font-semibold truncate">{cycle.name}</h3>
        {cycle.description && (
          <p className="text-sm text-gray-600 mt-0.5 line-clamp-2">{cycle.description}</p>
        )}
        {hasDates && (
          <p className="flex items-center gap-1.5 text-xs text-gray-500 mt-1.5">
            <CalendarIcon className="h-3.5 w-3.5 flex-shrink-0" />
            {cycle.date_init || '—'} to {cycle.date_end || '—'}
          </p>
        )}
      </div>
    </div>
  );
};

export default CardCoreCycle;
